<template>
  <section ref="anchor" class="free">
    <div class="free__content">
      <div class="free__content_left">
        <div class="free__content_left-top">
          <div class="font-40-48">
            <span class="text-blue">{{ content.left.titleOne }}</span>

            <span>{{ content.left.titleTwo }}</span>
          </div>

          <div class="font-18-24">{{ content.left.descriptionTop }}</div>

          <div
            class="font-small button"
            @click="$emit('show-form-presentation')"
          >
            {{ content.left.button }}
          </div>
        </div>

        <div class="free__content_left-bot">
          <div class="right-line-max" />
          <div class="right-line-middle" />

          <div class="font-24-30-bold text-white">
            {{ content.left.descriptionBottom }}
          </div>
        </div>
      </div>

      <div class="free__content_right">
        <img
          :src="`/img/${content.right.img}`"
          class="free__content_right-image"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { freeBlock } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'FreePeriod',
  mixins: [offsetMixin],
  data() {
    return {
      content: freeBlock,
    }
  },
}
</script>

<style lang="sass" scoped>
.free
  background: $textLightWhite
  padding: 8rem $desktopHorizontalPaddings 8rem
  @media (max-width: 1279px)
    padding: 4rem $mobileHorizontalPaddings 4rem
  &__content
    display: flex
    justify-content: space-between
    gap: 3rem
    @media (max-width: 1279px)
      flex-direction: column
      justify-content: flex-start
      margin-top: 2.4rem
      margin-bottom: 0
    &_left
      display: flex
      flex-direction: column
      gap: 3rem
      width: calc(55% - 1.5rem)
      flex-shrink: 0
      @media (max-width: 1279px)
        width: 100%
        flex-shrink: 1
      &-top
        background: $textWhite
        border-radius: 30px
        display: flex
        flex-direction: column
        gap: 2.4rem
        padding: 4rem
        flex-grow: 1
      &-bot
        background: $textPrimary
        border-radius: 30px
        display: flex
        flex-direction: column
        gap: 2.4rem
        padding: 4rem 4rem 7rem
        position: relative
        overflow: hidden
        flex-grow: 1
        @media (max-width: 1279px)
          margin: 0
          flex-grow: 0
    &_right
      display: flex
      flex-direction: column
      width: calc(45% - 1.5rem)
      flex-shrink: 0
      @media (max-width: 1279px)
        width: 100%
        flex-shrink: 1
      &-image
        width: 100%
        height: 100%
        max-height: 100%
        border-radius: 20px
        object-fit: cover
        object-position: center
        align-self: flex-start
        @media (max-width: 1279px)
          border-radius: 16px
          height: 400px
          align-self: stretch
        @media (max-width: 768px)
          height: 300px

.text-blue
  color: $buttonPrimary
  font-weight: 500

.text-white
  color: $textWhite

.button
  width: 289px
  height: 5rem
  padding: 1rem 3rem
  border-radius: 50px
  background-color: $buttonPrimary
  display: flex
  justify-content: center
  align-items: center
  color: $textWhite
  cursor: pointer
  transition: background-color 0.3s ease
  @media (max-width: 768px)
    height: auto

// украшательные линии
.right-line-middle, .right-line-max
  position: absolute
  background: transparent
  border: 1px solid $buttonPrimary

.right-line-middle
  right: -27.13vw
  bottom: -59.33vw
  width: 84.53vw
  height: 74.93vw
  border-radius: 21.33vw
  @media (min-width: 768px) and (max-width: 1279px)
    right: -25.13vw
    bottom: -68.33vw
  @media (min-width: 1280px)
    right: -26.31vw
    bottom: -11.65vw
    width: 48.02vw
    height: 19.69vw
    border-radius: 7.76vw
.right-line-max
  right: -32.52vw
  bottom: -64.93vw
  width: 103.2vw
  height: 93.6vw
  border-radius: 27.73vw
  @media (min-width: 768px) and (max-width: 1279px)
    right: -32.52vw
    bottom: -77.93vw
  @media (min-width: 1280px)
    right: -40.52vw
    bottom: -24.28vw
    width: 58.44vw
    height: 29.01vw
    border-radius: 7.76vw
</style>
